import generatePicker from 'antd/es/date-picker/generatePicker';
/* eslint-disable-next-line no-restricted-imports */
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';
import { getDayjs, getDayjsNow } from '../../utils';

/**
 * Custom DatePicker component using custom getDayjs() in place of dayjs().
 * This is due to known limitation of antd DatePicker: https://github.com/ant-design/ant-design/issues/47490.
 */
export const DatePicker = generatePicker({
  ...dayjsGenerateConfig,
  getNow: function getNow() {
    return getDayjsNow();
  },
  getFixedDate: function getFixedDate(string) {
    return getDayjs(string, 'YYYY-MM-DD')!;
  },
  locale: {
    ...dayjsGenerateConfig.locale,
    getWeekFirstDay: function getWeekFirstDay(locale) {
      return getDayjsNow().locale(locale).localeData().firstDayOfWeek();
    },
    getShortWeekDays: function getShortWeekDays(locale) {
      return getDayjsNow().locale(locale).localeData().weekdaysMin();
    },
    getShortMonths: function getShortMonths(locale) {
      return getDayjsNow().locale(locale).localeData().monthsShort();
    },
    parse: function parse(locale, text, formats) {
      const localeStr = locale;
      for (let i = 0; i < formats.length; i += 1) {
        const format = formats[i];
        const formatText = text;
        if (format.includes('wo') || format.includes('Wo')) {
          // parse Wo
          const year = formatText.split('-')[0];
          const weekStr = formatText.split('-')[1];
          const firstWeek = getDayjs(year, 'YYYY')
            ?.startOf('year')
            .locale(localeStr);
          if (firstWeek?.isValid()) {
            for (let j = 0; j <= 52; j += 1) {
              const nextWeek = firstWeek.add(j, 'week');
              if (nextWeek.format('Wo') === weekStr) {
                return nextWeek;
              }
            }
          }
          return null;
        }
        const date = getDayjs(formatText, format, true)?.locale(localeStr);
        if (date?.isValid()) {
          return date;
        }
      }
      return null;
    },
  },
});
